import { postSurveyResponses, getAccessToken } from "../APIConnector";

const key = (id) => `survey:${id}:answers`;
const startedKey = (id) => `survey:${id}:startedAt`;

export function loadAnswers(id) {
    try {
        return JSON.parse(sessionStorage.getItem(key(id)) || "{}");
    }
    catch { return {}; }
}

export function saveAnswer(id, questionId, value, page) {
    const all = loadAnswers(id);
    all[questionId] = { value, page };
    sessionStorage.setItem(key(id), JSON.stringify(all));
}

export function clearAnswers(id) {
    sessionStorage.removeItem(key(id));
    sessionStorage.removeItem(startedKey(id));
    sessionStorage.removeItem(`survey:${id}:maxPage`);
}

export function markStarted(id) {
    if (!sessionStorage.getItem(startedKey(id))) {
        sessionStorage.setItem(startedKey(id), new Date().toISOString());
    }
}

export function buildPayload({ id, survey, language }) {
    const answers = loadAnswers(id);
    return {
        surveyId: id,
        lang: language || survey?.language || "pl",
        startedAt: sessionStorage.getItem(startedKey(id)),
        completedAt: new Date().toISOString(),
        answers
    };
}

export async function submitAnswers({ id, survey, language, participantID }) {
    const body = buildPayload({ id, survey, language });
    body.user = participantID
    const data = await postSurveyResponses(body);
    return data;
}
